import PropTypes from 'prop-types';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import CustomTextField from '../common/CustomTextField';
import * as formValidations from '../../helpers/validations';
import './MFAScreen.scss';

const MFAScreen = props => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(props.defaultEmail || '');
  const [code, setCode] = useState('');
  const [blurred, setBlurred] = useState({});
  const emailIsValid = formValidations.email(email);
  const codeIsValid = /^[\d]{7,7}$/.test(code);

  return (
    <Stack className='MFAScreen' justifyContent='center' alignItems='center'>
      <Container maxWidth='sm'>
        <Stack spacing={2}>
          {
            props.errorMessage
            ? <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              {props.errorMessage}
            </Alert>
            : <></>
          }

          {
            props.resent
            ? <Alert severity="success">
              <AlertTitle>Success</AlertTitle>
              New code sent!
            </Alert>
            : <></>
          }

          {
            props.email
            ? null
            : <CustomTextField
              id='emailInput'
              placeholder='jane.smith@gmail.com'
              variant='outlined'
              label='Email'
              required
              type='email'
              error={!emailIsValid && blurred.email}
              defaultValue={props.defaultEmail || ''}
              onBlur={() => setBlurred({...blurred, email: true})}
              onChange={e => setEmail(e.target.value)}
            />
          }

          <CustomTextField
            id='codeInput'
            placeholder='Enter your code'
            variant='outlined'
            label='Code'
            autoFocus={true}
            required
            type='code'
            error={!codeIsValid && blurred.code}
            onBlur={() => setBlurred({...blurred, code: true})}
            onChange={e => setCode(e.target.value)}
            onKeyPress={e => {
              if (e.key === 'Enter') {
                props.onSubmit({email: props.email || email, code});
              }
            }}
            helperText='Check your email for the 7-digit code'
          />

          <Stack direction='row' spacing={1} justifyContent='center'>
            <Button
              variant='primaryOutline'
              size='medium'
              onClick={() => navigate('/login')}
            >
              Back
            </Button>

            <Button
              variant='primaryGradient'
              size='medium'
              onClick={() => props.onSubmit({email: props.email || email, code})}
            >
              Login
            </Button>
          </Stack>

          <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
            <Button
              onClick={() => props.onResend({email: props.email || email})}
            >
              Send a new code
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
};

MFAScreen.propTypes = {
  email: PropTypes.string,
  resent: PropTypes.bool,
  errorMessage: PropTypes.string,
  onSubmit: PropTypes.func, // ({email, code}) => { doSomething() }
  onResend: PropTypes.func, // ({email}) => { doSomething() }
};

export default MFAScreen;
